import { REQUIRED_MESSAGES } from '@srm/ui/lib/requiredMessage';
import InputNumberControl from '@srm/ui/controls/InputNumberControl';
import { IRatingScaleProps } from './IRatingScaleProps';
import { RatingScaleFrame } from './RatingScaleFrame';

interface IRatingScaleNumberProps extends IRatingScaleProps {
    scaleClassName: string;
}

/** Шкала с баллом, вводимым вручную: 0..5, округление до сотых */
export const RatingScaleNumber = ({ scaleClassName, ...props }: IRatingScaleNumberProps) => {
    const { isEdit, methods } = props;

    return (
        <RatingScaleFrame {...props} scaleClassName={scaleClassName}>
            <InputNumberControl
                label="Балл"
                name="offerCrit.score"
                required={true}
                readOnly={!isEdit}
                disabled={!isEdit}
                floatPoints={2}
                min={0}
                max={5}
                control={methods.control}
                rules={{ required: REQUIRED_MESSAGES.number }}
            />
        </RatingScaleFrame>
    );
};
